//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    titleType: String,
    titleName: String
  },
  computed: {
    title() {
      if (this.titleName) {
        return this.titleName;
      }
      if (this.titleType) {
        switch (this.titleType) {
          case "basic-config":
            return "基本配置";
        }
      }
      return "条件搜索";
    }
  },
  methods: {}
};